import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackIntegrationsSearched.meta';

export type UseTrackIntegrationsSearchedParams = {
  search_query: string;
};

export const useTrackIntegrationsSearched = () => {
  const { track } = useAnalyticsUtilities();

  const trackIntegrationsSearched = useCallback(
    (params: UseTrackIntegrationsSearchedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackIntegrationsSearched };
};
